import { EventEmitter } from "events";
import dispatcher from "../dispatchers/dispatcher";
import Common from "../constants/common";

class GenericContainerTypeStore extends EventEmitter {
    constructor() {
        super();
        this.initialData();
    }

    initialData() {
        this.relationshipChoices = {};
        this.containerTypes = [];
        this.relationships = [];
        this.relationshipDetails = {};
        this.containerTypeDetails = {};
        // this.runningContainers = [];
        this.runningContainerDetails = {};
        this.collectionItems = {};
        this.attachedCollections = {};
        this.savedTableColumns = {};
        this.autoCreateItemConfig = [];
        this.contTypeRunContainersOption = {
            count: 0,
            result: []
        };
        // used to store the selected container for alias extra fields
        this.selectedItems = {};
        this.taxSummary = [];
        this.fromContainerId = {};
        this.selectedLineItemDetails = {};
        this.hsnDetails = [];
        this.containerEfDropdownData = {};
        this.selectedContainer = {};
    }
    _containerTypeUpdate(action) {
        let data = this.containerTypes.slice(0);
        data.push(action.data);
        this._setData("containerTypes", data, "ContainerTypes");
    }

    _deleteContainerType(action) {
        let data = this.containerTypes.filter(el => el.ct_id != action.ct_id);
        this._setData("containerTypes", data, "ContainerTypes");
    }

    _deleteContainerRelation(id) {
        let data = this.relationships.filter(el => el.relation_id != id);
        this._setData("relationships", data, "Relationships");
    }

    _setCollectionItems({ data, resetPrevData }) {
        if (resetPrevData) {
            this.collectionItems = data;
        } else {
            this.collectionItems.result = this.collectionItems.result.concat(data.result);
        }
        this.emit("change", "Collection_Items");
    }

    _setSavedColumns({ data, ct_id }) {
        let columns = JSON.parse(JSON.stringify(this.savedTableColumns));
        columns[ct_id] = data;
        this._setData("savedTableColumns", columns, "Saved_Table_Columns");
    }

    _getSavedTableColumns(ct_id) {
        if (ct_id) return this.savedTableColumns[ct_id] || [];
        return this.savedTableColumns;
    }

    _clearSelectedItem(con_type) {
        this.selectedItems[con_type] = {};
    }

    _storeSelectedItem(obj, con_type) {
        this.selectedItems[con_type] = {};
        this.selectedItems[con_type] = Object.assign({}, this.selectedItems[con_type], obj);
    }

    /* This function will remove info of container type extrafield 
	which is dependent on some extrafield and value of that extrafield is made empty */
    _removeContainerEFInfo(id, con_type) {
        if (
            this.selectedItems &&
            this.selectedItems[con_type] &&
            id in this.selectedItems[con_type]
        ) {
            delete this.selectedItems[con_type][id];
            this.selectedLineItemDetails[con_type] = {};
        }
        this.containerEfDropdownData[con_type] = {};
        this.selectedContainer[con_type] = {};
    }

    _getSelectedItem(con_type) {
        return this.selectedItems[con_type] || {};
    }

    _storeFromContainerId(obj) {
        // this.fromContainerId = Object.assign({}, this.fromContainerId, obj);
        this.fromContainerId = obj;
    }

    _storeMapForSelectedRow(obj, con_type) {
        this.selectedLineItemDetails[con_type] = {};
        this.selectedLineItemDetails[con_type] = Object.assign({}, obj);
    }

    _getMapForSelectedRow(con_type) {
        return this.selectedLineItemDetails[con_type] || {};
    }

    _getFromContainerId() {
        return this.fromContainerId;
    }

    _setData(fieldName, data, emitString) {
        this[fieldName] = data;
        this.emit("change", emitString);
    }

    _getData(fieldName, fromPage) {
        if (fromPage && fromPage === "forDashboard") {
            let obj = {},
                data = this[fieldName].slice(0);
            for (let i of data) {
                if (i.group_order) {
                    if (!obj[i.group_order]) {
                        obj[i.group_order] = [];
                    }
                    obj[i.group_order].push(i);
                } else continue;
            }
            for (let key in obj) {
                let tempArr = obj[key];
                tempArr.sort((a, b) => a.container_order - b.container_order);
            }
            return obj;
        }
        return this[fieldName];
    }

    _clearFieldData(fieldName) {
        // this[fieldName] = {};
        delete this[fieldName];
    }

    _saveHSNDetails(hsnDetails, emitstring) {
        this.hsnDetails = hsnDetails;
        this.emit("change", emitstring);
    }

    _getHSNDetails() {
        return this.hsnDetails;
    }

    _initCtEdit(containerType, ct_id) {
        this["containerTypeDetails_" + ct_id] = containerType;
        this.emit("change", "initCtEdit");
    }

    _setContainerEfDropdownData(data, con_type) {
        if (!this.containerEfDropdownData[con_type]) {
            this.containerEfDropdownData[con_type] = {};
        }
        this.containerEfDropdownData[con_type] = Object.assign(
            this.containerEfDropdownData[con_type],
            data.values
        );
        this.emit("change", "containerEfDropdownData");
    }
    _getContainerEfDropdownData(con_type) {
        return this.containerEfDropdownData[con_type] || {};
    }
    _setSelectedContainer(data, id, con_type) {
        this.selectedContainer[con_type] = {};
        this.selectedContainer[con_type] = Common._perfectClone(data);
        this.emit("change", "selectedContainer", id);
    }
    _getSelectedContainer(con_type) {
        return this.selectedContainer[con_type] || {};
    }
    _handleActions(action) {
        switch (action.type) {
            case "Data_Fetched": {
                this._setData(action.fieldName, action.data, action.emitString);
                break;
            }
            case "Collection_Items": {
                this._setCollectionItems(action);
                break;
            }
            case "ContainerType_Update": {
                this._containerTypeUpdate(action);
                break;
            }
            case "ContainerType_Delete": {
                this._deleteContainerType(action);
                break;
            }
            case "ContainerRelation_Delete": {
                this._deleteContainerRelation(action.id);
                break;
            }
            case "Saved_Table_Columns": {
                this._setSavedColumns(action);
                break;
            }
            case "AddEditContainerSuccess": {
                this.emit("change", action.type);
                break;
            }
            case "EmitOnly": {
                this.emit("change", action.emitString);
                break;
            }
            case "INSTANCEVISIBILITY_CT": {
                this.emit("change", "INSTANCEVISIBILITY_CT", action.response);
                break;
            }
            case "CLEAR_ALL": {
                this.initialData();
                break;
            }
            case "HSN_DETAILS": {
                this._saveHSNDetails(action.data, action.emitString);
                break;
            }
            case "INIT_CT_EDIT": {
                this._initCtEdit(action.containerType, action.ct_id);
                break;
            }
            case "CONTAINER_DROPDOWN_DATA": {
                this._setContainerEfDropdownData(action.data, action.con_type);
                break;
            }
            case "SELECTED_CONTAINER_INFO": {
                this._setSelectedContainer(action.response, action.id, action.con_type);
                break;
            }
        }
    }
}

const store = new GenericContainerTypeStore();
if (process.env.NODE_ENV !== "production") window.genericContainerTypeStore = store;
dispatcher.register(store._handleActions.bind(store));
export default store;
